

exports.__esModule = true;
exports.getAllowOpenButtonFallback = getAllowOpenButtonFallback;

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _squid = require('squid');

var _logger = require('xo-beaver/dist/logger');

require('squid/index');

require('components/xo-beaver/dist/logger');

require('components/xo-return-to-merchant/dist/util');

require('components/xo-models/src/checkout/index');

var _constants = require('./constants');

var _customUtil = require('./customUtil.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// handler for UI fallbacks for all unhandled and handled errors
// fallbacks to Legacy in case of Open button flow
// fallbacks to generic error page in case of Add to cart flow
// All Legacy fallbacks are POST fallbacks. After the POST request - it goes to routes/index.js (/fallback POST handler)


(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

_angular2['default'].module().factory('$fallbackErrorHandler', function ($q, $meta, $timeout, $window, $log, $feature, $ReturnToMerchant, $locale, $util, $FallbackError, $state, $rootScope, $populate) {
    return function (err) {
        var reason = err.reason;
        var product = err.product || 'ux';
        var entry_point = err.entryPoint;
        var params = err.params;

        // construct url to the backend route - /fallback located in the routes/index.js
        function getFallbackOpenButtonUrl(urlParams) {
            var base = _squid.$config.urls.fallbackUrl['openButton'];
            return $util.paypalURL(base, urlParams);
        }

        function getFallbackShoppingCartUrl(urlParams) {
            var base = _squid.$config.urls.fallbackUrl['shoppingCart'];
            return $util.paypalURL(base, urlParams);
        }

        function doFallback() {
            $util.assert(reason, 'expected fallback reason');
            var xClickParams = _customUtil.customUtil.decodeAndParse($meta.xclickParams);

            // if open button flow we fallback to the legacy and form log messages
            var urlParams = params || {};

            _angular2['default'].extend(urlParams, {
                fallback: 1,
                landing: entry_point,
                useraction: $util.param('useraction'),
                flowlogging_id: $util.param('flowlogging_id')
            });

            var eventName = void 0;
            if (xClickParams.wa_type === _constants.BUYNOW_WA_TYPE) {
                eventName = 'shoppingcart_open_button_fallback';
            } else {
                eventName = 'shoppingcart_fallback';
            }
            _logger.$logger.info(eventName, {
                reason: reason,
                xClickParams: xClickParams
            });

            _logger.$logger.log(product ? 'info' : 'error', 'fallback', {
                reason: reason,
                product: product,
                entry_point: entry_point,
                error_desc: reason,
                from: $rootScope.currentState || 'fallback',
                to: product ? 'process_fallback_' + product : 'process_fallback'
            });

            var url = void 0;
            if (xClickParams.wa_type === _constants.SHOPPINGCART_WA_TYPE) {
                if (_squid.$config.denyShoppingCartFallBacks) {
                    _logger.$logger.info('shoppingcart_fallback_disabled');
                    return $state.go('checkout.genericError');
                }
                url = getFallbackShoppingCartUrl(urlParams);
                if (reason !== 'shoppingcart_checkout_fallback') {
                    xClickParams['shopping_cart_node_fallback'] = true;
                } else {
                    delete xClickParams['add'];
                    xClickParams['display'] = 1;
                }
            } else {
                url = getFallbackOpenButtonUrl(urlParams);
            }
            $rootScope.$emit('loading');
            // remove cmd param before falling back to the legacy
            // since fallback url already have it and it will cause the fallback error
            delete xClickParams['cmd'];
            delete xClickParams['submit'];
            return $ReturnToMerchant.postTo(url, xClickParams);
        }

        return doFallback();
    };
});

/**
 * Check whether an app can fallback to legacy based on the config property
 * @return {Boolean}
 */
function getAllowOpenButtonFallback() {
    var allowFallback = !_squid.$config.denyOpenButtonFallbacks;

    _logger.$logger.info('allow_fallback_config', { allowFallback: allowFallback });
    return allowFallback;
}

_squid.$config;

_logger.$logger;

_constants.BUYNOW_WA_TYPE;

_constants.SHOPPINGCART_WA_TYPE;

_customUtil.customUtil;


//////////////////
// WEBPACK FOOTER
// ./js/lib/fallback.js
// module id = ./js/lib/fallback.js
// module chunks = 1